module.exports = __webpack_public_path__ + "img/banner02.cb64c1ab.jpg";